import { useCallback, useState } from 'react';

export const useCreatorsSelection = () => {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
  const [isAllSelected, setAllSelected] = useState(false);

  const isSelected = useCallback(
    (id: string) => {
      if (isAllSelected) return true;
      return selectedIds.has(id);
    },
    [isAllSelected, selectedIds],
  );

  const toggle = useCallback((id: string) => {
    setAllSelected(false);
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);

  const toggleAll = useCallback(() => {
    setSelectedIds(new Set());
    setAllSelected((prev) => !prev);
  }, []);

  const selectedCount = selectedIds.size;

  const getSelectedIds = useCallback(() => Array.from(selectedIds), [selectedIds]);

  const clearSelection = useCallback(() => {
    setSelectedIds(new Set());
    setAllSelected(false);
  }, []);

  return {
    selectedIds,
    selectedCount,
    isSelected,
    isAllSelected,
    toggle,
    toggleAll,
    getSelectedIds,
    clearSelection,
  };
};
